import React, { useMemo } from 'react';
import { Button, Typography } from '@mui/material';
import { useIntl, FormattedMessage } from 'react-intl';
import Config from '../../../../../../config';
import { ReactComponent as MacIcon } from '../icons/mac_icon.svg';
import useStyles from './useStyles';

export type DownloadMacOsAppProps = {
  focus?: boolean;
};

export const DownloadMacOsApp = ({
  focus = false
}: DownloadMacOsAppProps): JSX.Element => {
  const classes = useStyles({ focus });
  const { formatMessage } = useIntl();

  const downloadDesktopMacAppValues = useMemo(
    () => ({
      variant: formatMessage({
        id: 'appMenu.macOs'
      })
    }),
    [formatMessage]
  );

  const macOsVersion = useMemo(
    () => ({ version: Config.desktopSupportedOSVersions.macos }),
    []
  );

  const macButtonIcon = useMemo(
    () => (
      <MacIcon className={classes.icon} fill={focus ? '#fff' : '#626262'} />
    ),
    [classes.icon, focus]
  );

  const buttonClasses = useMemo(
    () => ({
      startIcon: classes.icon,
      root: classes.button
    }),
    [classes.icon, classes.button]
  );
  return (
    <Button
      data-testid="mac-app-download"
      variant={focus ? 'contained' : 'outlined'}
      color={focus ? 'primary' : 'inherit'}
      startIcon={macButtonIcon}
      classes={buttonClasses}
      href={Config.downloads.mac}
    >
      <div className={classes.buttonContentContainer}>
        <Typography className={classes.buttonText} variant="body1">
          <FormattedMessage
            id="appMenu.downloadDesktopApp"
            values={downloadDesktopMacAppValues}
          />
        </Typography>
        <Typography className={classes.buttonText} variant="caption">
          <FormattedMessage id="appMenu.requires" values={macOsVersion} />
        </Typography>
      </div>
    </Button>
  );
};

export default DownloadMacOsApp;
